import { createFileRoute, Outlet, useMatchRoute } from '@tanstack/react-router';
import { PERMISSION_RIDES } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import TripsOverviewNew from '../../components/TripsOverviewNew';

export const Route = createFileRoute('/_authenticated/overview_tours')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_RIDES, ['read'], '/unauthorized', context);

    return {
      ...context,
      isNavigatorEnabled: true,
      documentTitle: {
        main: 'menu.rideBook',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: TripsOverviewRoute,
});

function TripsOverviewRoute() {
  const matchRoute = useMatchRoute();
  const isEcoDriveSubpage = Boolean(
    matchRoute({ to: '/overview_tours/eco_drive/$vehicleId/$rideId' })
  );

  return (
    <>
      {!isEcoDriveSubpage && <TripsOverviewNew />}
      <Outlet />
    </>
  );
}
